import React, { FC } from 'react';
import Table from 'antd/es/table';

interface Props {
  label: string,
  changes: {
    key: string;
    currentValue: any;
    isValueChanged: 'updated' | 'new' | 'none';
    newValue: any;
  }[]
}

const DiffTable: FC<Props> = ({ label, changes }) => {
  const getColorValue = (color, value, isValueChanged: 'new' | 'updated' | 'none') => {
    switch (isValueChanged) {
      case 'new':
        return value ? color : 'rgb(242, 242, 242)';
      case 'updated':
        return value ? color : 'rgb(242, 242, 242)';
      default:
        return '';
    }
  };

  const columns = [
    {
      title: 'Key',
      dataIndex: 'key',
      key: 'key',
    },
    {
      title: 'Current value',
      dataIndex: 'currentValue',
      key: 'currentValue',
      onCell: ({ currentValue, isValueChanged }) => ({
        style: {
          background: getColorValue('rgba(255,129,130,0.3)', currentValue, isValueChanged),
        },
        children: <div>{currentValue}</div>,
      }),
    },
    {
      title: 'New value',
      dataIndex: 'newValue',
      key: 'newValue',
      onCell({ newValue, isValueChanged }) {
        return {
          style: {
            background: getColorValue('rgba(74,194,107,0.3)', newValue, isValueChanged),
          },
          children: <div>{newValue}</div>,
        };
      },
    },
  ];

  return (
    <div style={{ paddingRight: 8, paddingLeft: 8 }} key={label}>
      <Table columns={columns} dataSource={changes} pagination={false} />
    </div>
  );
};

export default DiffTable;
